import { baseErrorMessages } from '@repo/lib/messages/baseErrorMessages';
import { useQuery } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { ParentKey } from './keys';
import { ParentService } from './parentService';

/**
 * One completed quiz attempt of a linked child, fetched on its own so a link to
 * it opens without the list it belongs to.
 *
 * Responds 404 when the attempt is not that child's, 403 when the child is not
 * linked to the authenticated parent.
 */
export function useGetChildQuizAttempt(childId: number | undefined, attemptId: string | undefined, enabled = true) {
  const query = useQuery({
    queryKey: [ParentKey.CHILD_QUIZ_ATTEMPT, childId, attemptId],
    queryFn: () => ParentService.getChildQuizAttempt(childId as number, attemptId as string).then((response) => response.data),
    enabled: enabled && typeof childId === 'number' && Boolean(attemptId),
  });
  const errorMessage = useErrorMessage(query.error, baseErrorMessages);
  return { ...query, errorMessage };
}
